import React from "react"
import {
  LineChart, Line, ResponsiveContainer
} from "recharts"

function WellbeingIndexChartTiny({ results }) {
  const datas = [...results.map((result, index) => ({ name: index, value: result.index }))].reverse()

  // accessibilityLayer defaults to true in recharts 3, which makes every sparkline
  // a tab stop with role="application". These are decorative repeats of the score
  // already rendered beside them, so opt out.
  return (
    <ResponsiveContainer>
      <LineChart width={300} height={300} data={datas} accessibilityLayer={false}>
        <Line type="monotone" dataKey="value" stroke="#8884d8" strokeWidth={2} />
      </LineChart>
    </ResponsiveContainer>
  )
}

export default WellbeingIndexChartTiny
